/**
 * 读取当前登录用户邮箱（Android Local 接口 username 字段）。
 * @returns {string}
 */
export const readUserEmail = () => {
  const readStoredUser = key => {
    try {
      return JSON.parse(localStorage.getItem(key) || '{}')
    } catch {
      return {}
    }
  }
  const userData = readStoredUser('userData')
  const currentEmail = userData?.data?.email || userData?.email
  if (currentEmail) return currentEmail

  const legacyUser = readStoredUser('userInfo')

  return legacyUser?.email || legacyUser?.data?.email || ''
}

/**
 * 读取 Android Local 设备的 UDID（优先 deviceContext.username，否则 DeviceUser.username）。
 * @param {Object} [context] - deviceContext，来自 Redux 或 readStoredDeviceContext
 * @returns {string}
 */
export const readLocalDeviceUdid = context => {
  if (context?.username) return context.username

  try {
    return JSON.parse(localStorage.getItem('DeviceUser') || '{}')?.username || ''
  } catch {
    return ''
  }
}
